import axios from './providers/axios';
import {convertBooleanValuesToNumbers} from "@/utils/utils";

const journeyService = {
    getJourneys(page, filters = []) {
        if (filters && filters.length > 0) {
            const tempFilters = filters.map((filter) => {
                return `&${filter.key}=${filter.value}`;
            }).join('');

            return axios.get(`/v1/admin/journey/store?limit=20&page=${page}${tempFilters}`);
        } else {
            return axios.get(`/v1/admin/journey/store?limit=20&page=${page}`);
        }
    },
    getJourneyFromProgram(page,programId, filters = []) {
        if (filters && filters.length > 0) {
            const tempFilters = filters.map((filter) => {
                return `&${filter.key}=${filter.value}`;
            }).join('');

            return axios.get(`/v1/admin/journey/store?limit=20&programId=${programId}&page=${page}${tempFilters}`);
        } else {
            return axios.get(`/v1/admin/journey/store?limit=20&programId=${programId}&page=${page}`);
        }
    },
    getJourneyDetails(id) {
        return axios.get(`/v1/admin/journey/getFromDetail/${id}`);
    },

    getJourneyWithDetail(journeyId, programModuleId){
        if (programModuleId){
            return axios.get(`/v1/admin/journey/getJourneyWithDetail/?journeyId=${journeyId}&programModuleId=${programModuleId}`);
        } else {
            return axios.get(`/v1/admin/journey/getJourneyWithDetail/?journeyId=${journeyId}`);

        }

    },
    getJourneyByStatus(type){
        return axios.get(`/v1/admin/journey/getJourneyByStatus/${type}`);
    },
    addJourneyNote(data) {
        data = convertBooleanValuesToNumbers(data);

        return axios.post(`/v1/admin/journey/note/add`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    endJourney(journeyIds) {
        return axios.post(`/v1/admin/journey/endJourney`, {
            journeyIds: journeyIds
        });
    },
    updateInterviewStatus(notificationId, status) {
        return axios.post(`/v1/admin/journey/interview/changeStatus`, {
            notificationId: notificationId,
            status: status
        });
    },

    journeyCreate(userId,programId){
        return axios.post(`/v1/admin/journey/add`, {
            programId: programId,
            userId: userId
        });
    }
}

export default journeyService;
